import { styled } from "@mui/material";
import Paper, { paperClasses } from "components/mui5/Paper";
import InputBase from "@mui/material/InputBase";

export const InputContainerPaper = styled(Paper)(({ theme }) => ({
  width: 320,
  height: theme.spacing(5),
  [`&.${paperClasses.rounded}`]: {
    borderRadius: theme.spacing(4),
  },
}));

export const PaddedInputBase = styled(InputBase)(({ theme }) => ({
  padding: theme.spacing(0.75, 2, 1, 3),
}));
